module.exports = __webpack_public_path__ + "cactus.jpg?fa6c2b22e3e1b7b8ec1fd9ba455fabed";